import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { theme, cardStyle, inputStyle, labelStyle } from '../theme';

const QuickFeedback = ({ patientId, API_BASE }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);

  const fetchFeedback = async () => {
    try {
      const r = await axios.get(`${API_BASE}/marketing/feedback?patientId=${patientId}`);
      // Filter client-side since API doesn't have patientId filter yet - use all and filter
      setFeedbacks(r.data.filter(f => String(f.patientId?._id || f.patientId) === String(patientId)));
    } catch(e) { setFeedbacks([]); }
  };

  useEffect(() => { fetchFeedback(); }, [patientId]); // eslint-disable-line

  const handleSave = async () => {
    if (!rating) return alert('Select a rating');
    setSaving(true);
    try {
      await axios.post(`${API_BASE}/marketing/feedback`, { patientId, rating, comment, source: 'in-clinic' });
      setRating(0); setComment(''); setShowForm(false); fetchFeedback();
    } catch(e) { alert('Failed'); }
    setSaving(false);
  };

  const fmtDate = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}) : '—';

  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px'}}>
        <h3 style={{margin:0, color:theme.navy}}>Patient Feedback</h3>
        <button onClick={()=>setShowForm(!showForm)}
          style={{padding:'9px 20px', backgroundColor:theme.primary, color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'bold'}}>
          {showForm ? '✕ Cancel' : '+ Take Feedback'}
        </button>
      </div>

      {showForm && (
        <div style={{...cardStyle, marginBottom:'18px', borderTop:`4px solid ${theme.warning}`, textAlign:'center'}}>
          <h4 style={{margin:'0 0 16px', color:theme.navy}}>How was your experience?</h4>
          <div style={{display:'flex', justifyContent:'center', gap:'8px', marginBottom:'16px'}}>
            {[1,2,3,4,5].map(n => (
              <button key={n} onClick={()=>setRating(n)}
                style={{
                  fontSize:'2rem', background:'none', border:'none', cursor:'pointer',
                  color: n <= rating ? theme.warning : '#ddd',
                  transform: n <= rating ? 'scale(1.2)' : 'scale(1)',
                  transition:'all 0.15s',
                }}>
                ★
              </button>
            ))}
          </div>
          {rating > 0 && <p style={{color:theme.textMuted, margin:'0 0 14px'}}>{['','Poor','Fair','Good','Very Good','Excellent'][rating]}</p>}
          <input value={comment} onChange={e=>setComment(e.target.value)} placeholder="Any comments? (optional)" style={{...inputStyle, maxWidth:'400px', margin:'0 auto 14px', display:'block'}}/>
          <button onClick={handleSave} disabled={saving}
            style={{padding:'10px 22px', backgroundColor:theme.success, color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'600'}}>
            {saving ? 'Saving...' : 'Submit Feedback'}
          </button>
        </div>
      )}

      {feedbacks.length === 0 ? (
        <div style={{textAlign:'center', color:'#bbb', padding:'40px', backgroundColor:'#fafafa', borderRadius:'10px'}}>
          No feedback recorded yet
        </div>
      ) : (
        <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
          {feedbacks.map(f => (
            <div key={f._id} style={{display:'flex', alignItems:'center', gap:'14px', padding:'12px 16px', backgroundColor:'#f8f9fa', borderRadius:'10px'}}>
              <div style={{fontSize:'1.2rem', color:theme.warning}}>{'★'.repeat(f.rating)}{'☆'.repeat(5-f.rating)}</div>
              <div style={{flex:1}}>
                {f.comment && <div style={{fontSize:'0.88rem', color:theme.navy}}>{f.comment}</div>}
                <div style={{fontSize:'0.75rem', color:theme.textSubtle}}>{fmtDate(f.createdAt)} • {f.source}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuickFeedback;
